export default "__VITE_ASSET__FMv7MAz2__"